export const FlagElement =  ()=>{
    return (
        <div className="container">
            <p>フラグはカードにつけられたフラグを表す項目です。以下の例ではflagが1のカードを表しています    </p>
            <p><img src={`${process.env.PUBLIC_URL}/dialogbox_flag.png`}></img></p>
        </div>
    )
}
